export default __webpack_public_path__ + "static/media/slider11.d24d9b44.jpeg";